import { render, staticRenderFns } from "./IntelliSvg.vue?vue&type=template&id=65a7dead"
import script from "./IntelliSvg.vue?vue&type=script&lang=js"
export * from "./IntelliSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports